<script>
    import { createEventDispatcher } from "svelte";
    import { link } from "svelte-routing";
    import { deleteJurisdictionByGroupAndYear } from "../../../services/jurisdictionService";
    import { isAdmin, isGroupManager } from "../../../stores/settingsStore";
    import { selectedActiveYear } from "../../../stores/selectedActiveYear";
    import DeleteButton from "../DeleteButton.svelte";
    import toast from "svelte-french-toast";

    const dispatch = createEventDispatcher();
    export let jurisdiction;

    // JurisdictionGroup shape (from backend): adjust the field names here if they differ
    $: groupId = jurisdiction.groupId ?? jurisdiction.group?.id;
    $: groupName = jurisdiction.groupName ?? jurisdiction.group?.name ?? "";
    $: year = jurisdiction.year ?? $selectedActiveYear;
    $: municipalitiesCount = jurisdiction.municipalities?.length ?? 0;

    function handleDelete() {
        deleteJurisdictionByGroupAndYear(groupId, year).then(() => {
            dispatch("delete", { state: "jurisdiction deleted" });
            toast.success("Sottogruppo eliminato");
        }).catch((err) => {
            console.error(err);
            toast.error(`Impossibile eliminare il sottogruppo, errore ${err.toString()}`);
        });
    }
</script>

<tr class="h-14 border-b">
    <td>{groupName}</td>
    <td>{municipalitiesCount}</td>
    <td>
        <div class="flex flex-col gap-0.5 py-2 pr-2" style="max-height: 5rem; overflow-y: auto;">
            {#each jurisdiction.municipalities ?? [] as municipality}
                <span class="text-sm whitespace-nowrap">{municipality.name}</span>
            {/each}
        </div>
    </td>
    <td class="text-right">
        {#if $isAdmin || $isGroupManager}
            <a
                use:link
                href="/admin/jurisdiction/edit?groupId={groupId}&year={year}"
                class="mr-3"
            >
                <span class="w-10 h-10 text-sm border inline-flex items-center justify-center rounded-full cursor-pointer">
                    <i class="fa fa-edit"></i>
                </span>
            </a>
        {/if}

        {#if $isAdmin}
            <DeleteButton
                buttonText="Elimina"
                message="Vuoi eliminare il sottogruppo?"
                buttonClass="w-44"
                on:delete={() => handleDelete()}
            />
        {/if}
    </td>
</tr>
